<template>
  <section id="reviews">
    <div class="center-container">
      <div class="content">
        <div class="review-item">
            <h2>Avaliações</h2>
            <h4>Opinião de quem já visitou</h4>
            <div class="reviews-stats">
               <table>
                 <tbody>
                    <tr>
                      <td>5</td>
                      <td>
                        <div class="review-bar-bg">
                          <div class="review-bar" style="width: 100%"></div>
                        </div>
                      </td>
                   </tr>
                   <tr>
                      <td>4</td>
                      <td>
                        <div class="review-bar-bg">
                          <div class="review-bar" style="width: 14.285714285714286%"></div>
                        </div>
                      </td>
                   </tr>
                   <tr>
                      <td>3</td>
                      <td>
                        <div class="review-bar-bg">
                          <div class="review-bar"></div>
                        </div>
                      </td>
                   </tr>
                   <tr>
                      <td>2</td>
                      <td>
                        <div class="review-bar-bg">
                          <div class="review-bar"></div>
                        </div>
                      </td>
                   </tr>
                   <tr>
                      <td>1</td>
                      <td>
                        <div class="review-bar-bg">
                          <div class="review-bar" style="width: 7.142857142857143%"></div>
                        </div>
                      </td>
                   </tr>
                 </tbody>
               </table>
               <div class="review-total">
                 <div class="number">
                  4,8
                 </div>
                 <div class="stars">
                    <i class="fas fa-star yellow"></i>
                    <i class="fas fa-star yellow"></i>
                    <i class="fas fa-star yellow"></i>
                    <i class="fas fa-star yellow"></i>
                    <i class="fas fa-star yellow"></i>
                 </div>
                 <div class="reviews-link">
                   <a target="_blank" href="https://www.google.com/maps/place/Pousada+Recanto+da+Fam%C3%ADlia/@-22.9344815,-46.5026296,17z/data=!4m7!3m6!1s0x94ceb60b95a501d1:0x555fd1074434403e!8m2!3d-22.9344865!4d-46.5004409!9m1!1b1">
                    30 comentários
                   </a>
                 </div>
               </div>
            </div>
            <a target="_blank" href="https://www.google.com/maps/place/Pousada+Recanto+da+Fam%C3%ADlia/@-22.9344815,-46.5026296,17z/data=!4m7!3m6!1s0x94ceb60b95a501d1:0x555fd1074434403e!8m2!3d-22.9344865!4d-46.5004409!9m1!1b1" class="btn btn-primary">Ver todos os comentários</a>
        </div>

        <div class="review-item">
          <div class="quote-icon">
            <i class="fas fa-quote-left"></i>
          </div>
          <div class="review">
            <div class="review-title">
              <h4>Recomendo e muito!</h4>
              <div class="stars">
                <i class="fas fa-star yellow"></i>
                <i class="fas fa-star yellow"></i>
                <i class="fas fa-star yellow"></i>
                <i class="fas fa-star yellow"></i>
                <i class="fas fa-star yellow"></i>
              </div>
            </div>
            <div class="review-text">
                Já é a 05 vez que passo um final de semana na pousada. Com sempre, fomos muito bem recebidos pela Sra. Jacira, a dona da Pousada, uma simpatia de pessoa. Ótimo ambiente para quem quer relaxar e se divertir com a família e amigos. Recomendo e muito!!!
            </div>
            <div class="review-footer">
              <img v-lazy="'https://lh3.googleusercontent.com/a/AATXAJyWrl36_5OCZ6634D-cS7p4lZJiCMoYAbnZh53w=w60-h60-p-rp-mo-br100'" class="author-photo" />
              Roger Cavalcante de Oliveira
            </div>
          </div>
        </div>

        <div class="review-item">
          <div class="quote-icon">
            <i class="fas fa-quote-left"></i>
          </div>
          <div class="review">
            <div class="review-title">
              <h4>Recomendo muitíssimo!</h4>
              <div class="stars">
                <i class="fas fa-star yellow"></i>
                <i class="fas fa-star yellow"></i>
                <i class="fas fa-star yellow"></i>
                <i class="fas fa-star yellow"></i>
                <i class="fas fa-star yellow"></i>
              </div>
            </div>
            <div class="review-text">
                Ambiente acolhedor, ótimas instalações, sem contar a simpatia da D. Jacira que é um detalhe a parte: carinhosa, hospitaleira e muito gentil. Quero voltar muitas e muitas vezes!!!
            </div>
            <div class="review-footer">
              <img v-lazy="'https://lh3.googleusercontent.com/a-/AOh14Gj8UAqLWXt_NYSFfQqXNHw-C3h4DmpD_HwyDihHtw=w60-h60-p-rp-mo-br100'" class="author-photo" />
              Vivian
            </div>
          </div>
        </div>

      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Reviews'
}
</script>
